import { useCallback, useEffect, useState } from 'react';
import { applyTheme, readThemePref, resolveTheme, systemPrefersDark, watchSystemScheme, writeThemePref, type Scheme, type ThemePref } from './theme';

/**
 * The remembered theme choice and the scheme it shows. index.html already applied it before the
 * first paint; this keeps <html data-theme> and meta theme-color in step with the toggle (and with
 * the OS while "system" is chosen).
 */
export function useTheme(): { pref: ThemePref; scheme: Scheme; setPref: (pref: ThemePref) => void } {
  const [pref, setPrefState] = useState<ThemePref>(readThemePref);
  const [systemDark, setSystemDark] = useState(systemPrefersDark);
  const { scheme } = resolveTheme(pref, systemDark);

  useEffect(() => watchSystemScheme(setSystemDark), []);
  useEffect(() => applyTheme(pref, scheme), [pref, scheme]);

  const setPref = useCallback((next: ThemePref) => {
    setPrefState(next);
    writeThemePref(next);
  }, []);

  return { pref, scheme, setPref };
}
